import axios from 'axios'
import { ApiAuth } from '../login/ApiAuth'

const apiAuth = new ApiAuth()


export default class Api{
    constructor(){
        this.SERVER_URL  = process.env.VUE_APP_SERVER_URL
        this.IMG_URL     = process.env.VUE_APP_IMG_URL
        this.TOKEN_URL   = this.SERVER_URL + 'token/'
        this.USUARIO     = 'conejofoz'
        this.PASSWORD    = '1234567.'
        this.credenciais = { username: this.USUARIO, password:this.PASSWORD}
    }


    async getToken_old(){
        const resposta = await fetch(
                                    this.TOKEN_URL,
                                    {
                                        method:"POST", 
                                        body:JSON.stringify(this.credenciais), 
                                        mode:"cors", 
                                        headers:{'Content-Type': 'application/json'
                                    }
                                })
        const token = await resposta.json()
        return token
    }


    async getToken(){
        console.log('entrou no get token da api')
        try {
            const token = await apiAuth.getToken()
            console.log('get token da api', token)
            if(token.detail){
                console.log('get token da api entrou no if', token)
                return token.detail
            }
            console.log('get token da api passou do if', token)
            return token
        } catch (error) {
            console.log('error no get token da api ', error)
            return error.toString()
        }
    }


    async get(recurso, id=-1, dataInicial="", dataFinal="", empresa=""){
        try {
            const token = await this.getToken()
            console.log(token)
        
        let url = this.SERVER_URL + recurso + '/' 

        if(id !== -1){
            url += id + '/'
        } else {
            if(dataInicial>""){
                if(empresa==""){
                    url += '?dataInicial='+dataInicial+'&dataFinal='+dataFinal
                } else{
                    url += '?dataInicial='+dataInicial+'&dataFinal='+dataFinal+'&empresa='+empresa
                }
            } else {
                if(!empresa==""){
                    url += '?empresa='+empresa
                }
            }
        }

        //try {
        
            const resposta = await fetch(url, {method: "GET",headers:{'Content-Type': 'application/json', 'Authorization': "Bearer " + token.access}})
            //if(resposta.status !== 200) throw new Error('ERRO DO SILVIÃO NO GET')
            console.log(resposta.status)
            if(resposta.status == 404) throw new Error('404')
            if(resposta){
                console.log('tem resposta na api')
            } else {
                console.log('não tem resposta na api')
            }

            console.log('resposta api: ', resposta)
            /* if(resposta.detail){
                console.log('detail..: ', resposta.detail)
            } */

            const itens = await resposta.json()
            console.log('itens na api principal: ', itens)


            if(itens.results===undefined){
                //return itens.dados //django retorando json - dados é o nome dado ao retorno lá do django poderia ser abacate
                return itens //django-rest framework
            }
                return itens.results

        } catch(error){
            console.log('Erro no get da api',error.toString())
            return error.message
        }

         
        
       
    }


    async saveNormalSemFotoApi(recurso, obj){
        const token = await this.getToken()
        let url = this.SERVER_URL + recurso +"/"
        let method = "POST"
        
        if(obj.id !== -1){
            method = "PUT"
            url += obj.id + "/"
        }

        try {
            let resposta = await fetch(url, {method: method, body:JSON.stringify(obj), headers:{'Content-Type': 'application/json', 'Authorization': "Bearer " + token.access,}})

            console.log('resposta pura: ', resposta)
            if(!resposta.ok){
                console.log('resposta do if: ', resposta.statusText)
                return resposta.statusText
                //return resposta
            }
    
            //const data = await resposta
            const data = await resposta.json()
            console.log('data: ', data)
            return data
        } catch (error) {
            console.log(error)            
        }

    }


    async save(recurso, obj){
        console.log('Objeto antes de gravar: ', obj)
        console.log('Valor do id: ', obj.get('id'))
        /* 
        Função modificada para fazer o upload da imagem ja na hora do cadastro
        Todos os componentes terão que converter seus objetos para formdata para serializar a imagem junto com os dados
            pois antes estava trabalhando com application/json, agora multipart/form-data
         */
        const token = await this.getToken()
        let url = this.SERVER_URL + recurso +"/"
        //let method = "POST"
        
        //if(obj.id !== -1){
            //method = "PUT"
           // url += obj.id + "/"
       // }
        if(obj.get('id') != -1){
            //method = "PUT"
            url += obj.get('id') + "/"
        }

        try {

            //let resposta = await fetch(url, {method: method, body:JSON.stringify(obj), headers:{'Content-Type': 'application/json', 'Authorization': "Bearer " + token.access,}})

            let resposta = null

            if(obj.get('id') == -1){
                resposta = await axios.post(url, 
                    obj,
                    {headers:{'Content-Type': 'multipart/form-data', 'Authorization': "Bearer " + token.access}}, 
                    {
                        onUploadProgress: uploadEvent =>{
                        console.log('Upload Progress: ' + Math.round(uploadEvent.loaded / uploadEvent.total * 100) + '%')
                    }
                })
                .then(res =>{
                    console.log('res', res)
                    return res //jogou o res para o resposta
                })

            } else {
                resposta = await axios.put(url, 
                    obj,
                    {headers:{'Content-Type': 'multipart/form-data', 'Authorization': "Bearer " + token.access}}, 
                    {
                        onUploadProgress: uploadEvent =>{
                        console.log('Upload Progress: ' + Math.round(uploadEvent.loaded / uploadEvent.total * 100) + '%')
                    }
                })
                .then(res =>{
                    console.log('res', res)
                    return res //jogou o res para o resposta
                })/* .catch(error=>{
                    console.log('Erro retornado do await: ', error)
                    return error
                }) */
                    
                

            }

            // 


            console.log('resposta pura: ', resposta)
            console.log('tipo da resposta pura :', typeof(resposta))
            console.log('resposta pura convertida para json :', JSON.stringify(resposta))
            console.log('resposta mensagem :', resposta.message)
            console.log('resposta config :', resposta.config)
            
            //if(!resposta.data.ok){ //axios não tem o propriedade ok
            //    console.log('resposta do if: ', resposta.data.statusText)
            //    return resposta.data.statusText
                //return resposta
            //}
    
            
            //const data = await resposta.json()
            //console.log('data: ', data)
            //return data
            if(resposta.data){
                console.log('existe data')
                return resposta.data
            } else{
                console.log('nao existe data')
                return resposta.message
            }

            
        } catch (error) {
            console.log("======================TRAYY=============================")
            console.log('Erro retornado do tray: ', error)            
            console.log('tipo do erro retornado do tray: ', typeof(error))
            console.log('ERRO do tray PARA JSON: ', JSON.stringify(error))
            console.log('ERRO do tray response: ', error.response)
            console.log('ERRO do tray response: ', JSON.stringify(error.response.data))
            //return error.message
            return JSON.stringify(error.response.data)
        }

    }


    async delete(recurso, id){
        const token = await this.getToken()
        let url = this.SERVER_URL + recurso + "/" + id + "/"

        try {
            let resposta = await fetch(url, {method: "DELETE",headers:{'Content-Type': 'application/json', 'Authorization': "Bearer " + token.access,}})
            .catch(error => console.log('Error: ', error))
            console.log('passou')
            console.log(resposta)
            console.log('resposta pura: ', resposta)
            console.log('tipo da resposta pura :', typeof(resposta))
            console.log('resposta pura convertida para json :', JSON.stringify(resposta))
            console.log('resposta mensagem :', resposta.message)
            console.log('resposta config :', resposta.config)
            console.log('resposta data :', resposta.data)
            return resposta
        } catch (error) {
            console.log(error)
            return error
        }
    }
}